import { makeUseFetchOne } from '@elentari/core'
import { lotesRepository, loteValidacaoById } from './lotesRepository'
import { LotesDetail } from '../types'

export const useLote = makeUseFetchOne<LotesDetail, string>({
  fetch: lotesRepository.fetchOne
})

export const useValidacaoLote = makeUseFetchOne<LotesDetail, string>({
  fetch: loteValidacaoById
})
